<template>
	<div class="mb-3">
		<h5 class="mb-3 font-weight-bold">Select Validation Status</h5>

		<GroupedOptions
			v-model="modelValue"
			:options="flagOptions"
      :disabled="disabled"
			native-type="checkbox"
			button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
			class="flag-options"
		/>
	</div>
</template>

<script>
import { uniq } from "lodash-es";
import { exportMixin, userMixin } from "@mixins";
import { flags } from "@datas";
import GroupedOptions from "@components/GroupedOptions";

export default {
	components: {
		GroupedOptions,
	},
	props: {
		value: {
			type: Array,
			default: () => ["3"],
		},
    disabled: {
			type: Boolean,
			default: () => false,
		}
	},
	data() {
		return {
			excludeOptions: [],
		};
	},
	mixins: [exportMixin, userMixin],
	computed: {
		modelValue: {
			get() {
				const value = this.value.map((item) => {
					if ("string" === typeof item) return item;

					if ("All_Error_Flag" === item.name) return "3";
					else if ("Critical_Error_Flag" === item.name && item.value)
						return "2";
					else if ("Non_Critical_Flag" === item.name && item.value)
						return "1";
					else return "0";
				});
				const lastSelected = value[value.length - 1];

				if (undefined == lastSelected) return ["3"];
				else return uniq(value);
			},
			set(value) {
				const lastSelected = value[value.length - 1];
				const isCombined =
					3 === value.length &&
					!value.filter((item) => !["0", "1", "2"].includes(item))
						.length;

				if ("3" === lastSelected || isCombined) {
					this.$emit("input", []);
				} else {
					const emitValues = [];

					value
						.filter((item) => 2 >= item)
						.forEach((item) => {
							if (0 == item) {
								if (!value.includes("1")) {
									emitValues.push({
										name: "Non_Critical_Flag",
										value: 0,
									});
								}

								if (!value.includes("2")) {
									emitValues.push({
										name: "Critical_Error_Flag",
										value: 0,
									});
								}
							} else if (1 == item) {
								emitValues.push({
									name: "Non_Critical_Flag",
									value: 1,
								});
							} else {
								emitValues.push({
									name: "Critical_Error_Flag",
									value: 1,
								});
							}
						});

					this.$emit("input", emitValues);
				}
			},
		},
		flagOptions() {
			return flags.map((item) => {
				item.disabled = this.excludeOptions.includes(item.value);

				return item;
			});
		},
	},
	methods: {
		async checkFlagOptions(flag) {
			await this.checkParameterDatasByColumn(
				"flag",
				"Coverholder_Name",
				this.companyRole,
				this.companyRoleValue,
				{
					flag: flag,
				}
			).then((response) => {
				if (!response.data.data.Coverholder_Name.length)
					this.excludeOptions.push(flag);
			});
		},
	},
	// async created() {
	// 	await this.checkFlagOptions("critical");
	// 	await this.checkFlagOptions("non-critical");
	// 	await this.checkFlagOptions("no-errors");
	// },
};
</script>

<style lang="scss">
.flag-options {
	max-width: 400px;

	.badge {
		&.active {
			&:nth-child(2) {
				background-color: #f5365c;
			}

			&:nth-child(3) {
				color: #000;
				background-color: #fcf93e;
			}

			&:last-child {
				background-color: #48b900;
			}
		}
	}
}
</style>
